import { BookingsInsightsReportDto } from './BookingsInsightsReportDto';
import { BookingsInsightsReport } from 'model/BookingsReport';

export const convertToBookingInsightsReport = (response: BookingsInsightsReportDto): BookingsInsightsReport => {
    return {
        totalAppointments: response.total_appointments,
        totalUpcoming: response.total_upcoming,
        percentUpcoming: response.percent_upcoming,
        totalCompleted: response.total_completed,
        percentCompleted: response.percent_completed,
        totalCancelled: response.total_cancelled,
        percentCancelled: response.percent_cancelled,
        totalNoShow: response.total_no_show,
        percentNoShow: response.percent_no_show,
        totalOnlineBooking: response.total_online_booking,
        percentOnlineBooking: response.percent_online_booking,
        totalBusinessBooked: response.total_business_booked,
        percentBusinessBooked: response.percent_business_booked,
        totalNewClients: response.total_new_customers,
        percentNewClients: response.percent_new_customers,
        totalReturningClients: response.total_returning_customers,
        percentReturningClients: response.percent_returning_customers
    };
};
